<template>
  <div class="uiwu-index-item uiwu-flex-column" :style="{'background':item.bgColor}">
      <h2 class="uiwu-index-item-title">{{item.title}}</h2>
        <p>{{item.doc}}</p>
        <picture>
            <source :srcset="item.icon_ios" media="(min-width: 300px) and (max-width: 1024px)">
            <img class="icon" :src="item.icon" alt="图片">
        </picture>
        

        <img class="uiwu-index-item-button" :src="item.img" alt="">
  </div>
</template>

<script>
/**
 * uiwuIndexItem
 *  @property 
 */
export default {
    name:'uiwuIndexItem',
    props:{
        item:{
            default:()=>{
                return {}
            },
            type:Object
        }
    }
}
</script>

<style lang="scss">
    $color:#010101;
    .uiwu-index-item{
        width: 486px;
        height: 580px;
        border-radius: 10px;
        justify-content: space-between;
        align-items: center;
        
        &-title{
            padding-top: 50px;
            text-align: center;
            font-size: 30px;
            font-weight: bold;
            color: $color;
        }
        p{
            font-size: 18px;
            font-weight: 400;
            color: $color;
            text-align: center;
            margin-bottom: 30px;
        }
        &-button{
           margin-top: 58px;
           width: 455px;
        }
        @media screen and (min-width: 768px) and (max-width:1024px)  {
            width: 100%;
        }
        
        @media screen and (min-width:320px) and (max-width:767px) {
            width: 100%;
            overflow: hidden;
            height: 8.6667rem;
            img{
                &.icon{
                    // width: 7.6rem;
                    width: auto;
                    height: .92rem;
                    margin-bottom: .2667rem;
                }
            }
            &-title{
                padding-top: .9333rem;
                font-size: .5067rem;
            }
            p{
                font-size: .32rem;
                margin-bottom: 0;
            }
            &-button{
                margin-top: 0;
                width: auto;
                height: 3.7333rem;
            }
        }
        
    }
</style>